"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanjiangOrderDetailApi = sanjiangOrderDetailApi;
exports.sanjiangOrderExportApi = sanjiangOrderExportApi;
exports.sanjiangOrderIntegralLogApi = sanjiangOrderIntegralLogApi;
exports.sanjiangOrderListApi = sanjiangOrderListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 三江直饮水订单列表
 * @param {Object} params 查询参数
 */
function sanjiangOrderListApi(params) {
  return (0, _request.default)({
    url: "admin/order/water/list",
    method: 'get',
    params: params
  });
}

//查看订单详情
function sanjiangOrderDetailApi(orderId) {
  return (0, _request.default)({
    url: "admin/order/water/detail/".concat(orderId),
    method: 'get'
  });
}

//订单导出order/water/export
function sanjiangOrderExportApi(params) {
  return (0, _request.default)({
    url: "admin/order/water/export",
    method: 'post',
    params: params
  });
}

//查看福豆
function sanjiangOrderIntegralLogApi(orderId) {
  return (0, _request.default)({
    url: "admin/order/station/getIntegralLog/".concat(orderId),
    method: 'get'
  });
}